import { ReactElement, useEffect, useState } from 'react';
import About from './About';
import RecipeIngredients from './RecipeIngredients';
import LimitedTimeOfferingFAQs from './LimitedTimeOfferingFAQs';
import { useLtoItemQuery } from '../../services/product/product.queries';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import { useAuth } from '../../contexts/AuthContext';
import styles from './LimitedTimeOffering.module.scss';
import LimitedTimeOfferingCurrentRecipeInfo from './LimitedTimeOfferingCurrentRecipeInfo';
import { LAST_LTO_WEEK_MENU_ID } from '../../constants/menu';

function RobinArzonLimitedTimeOfferingPDP(): ReactElement {
  const [currentLTORecipe, setCurrentLTORecipe] = useState(0);

  const { isLoggedIn } = useAuth();
  const {
    menuWithCartItems,
    menu,
    upcomingMenus,
    updateCartQuantity,
    onSelectMenu,
  } = useMenuWithCart();
  const ltoMenuItem = menuWithCartItems.find(
    (item) => item.isLtoBox,
  );
  const { data: ltoItem } = useLtoItemQuery('eat-to-hustle-x-purple-carrot');
  const currentLtoComponent = ltoItem?.components.find(
    (item) => item.itemNumber === currentLTORecipe,
  );

  useEffect(() => {
    // if the LTO is OOS for the current week, and we are not currently on the last LTO week,
    // switch to the next menu week and check again
    if (isLoggedIn && ltoMenuItem && !ltoMenuItem?.isInStock
      && menu?.id !== LAST_LTO_WEEK_MENU_ID) {
      let currentMenuWeekIndex: number;
      const nextMenuWeek = upcomingMenus?.menus.find((upcomingMenu, index) => {
        if (upcomingMenu.id === menu?.id) {
          currentMenuWeekIndex = index;
        }
        return index === currentMenuWeekIndex + 1;
      });
      if (nextMenuWeek) {
        onSelectMenu(nextMenuWeek.id, nextMenuWeek.cartId);
      }
    }
  }, [isLoggedIn, ltoMenuItem, menu, upcomingMenus, onSelectMenu]);

  const aboutContent = (
    <>
      <div className={styles.square} />

      <div className={styles.square} />

      <div className={styles.square}>
        <h1>Fueling Your Hustle With Robin Arzon</h1>
        <p>
          Robin has been plant-based for over 10 years—but it didn’t happen overnight.
          It started with one meal, one day, one week at a time, and evolved into a
          fully plant-based lifestyle for her and her family. She believes in the power
          of plants to fuel big lives.
        </p>
        <p>
          Now, with Purple Carrot, she’s making plant-based meals easy,
          satisfying, and packed with protein.
        </p>
        <p>
          <span>
            In celebration of
            {' '}
            <i>
              Eat To Hustle, Robin’s new cookbook of 75 plant-based,
              protein-packed meals,
            </i>
            {' '}
            Purple Carrot is teaming up with Robin to show
            you how plants can power any hustle – and there’s no better time to start
            than now.
          </span>
        </p>
      </div>
    </>
  );

  return (
    <div className={styles.limited_time_offering}>
      <LimitedTimeOfferingCurrentRecipeInfo
        onUpdateCartQuantity={updateCartQuantity}
        ltoMenuItem={ltoMenuItem}
        currentLtoComponent={currentLtoComponent}
        setCurrentLTORecipe={setCurrentLTORecipe}
        currentLTORecipe={currentLTORecipe}
        ltoItem={ltoItem}
        totalNumberOfRecipes={4}
      />
      {currentLTORecipe === 0 ? (
        <>
          <About title="Fueling Your Hustle With Robin Arzón">
            {aboutContent}
          </About>
          <div className={styles.expandable_section}>
            <LimitedTimeOfferingFAQs questions={ltoItem?.faqs} />
          </div>
        </>
      ) : (
        <>
          <div className={styles.expandable_section}>
            <RecipeIngredients ingredients={currentLtoComponent?.ingredients} />
            <LimitedTimeOfferingFAQs questions={ltoItem?.faqs} />
          </div>
          <About title="Fueling Your Hustle With Robin Arzón">
            {aboutContent}
          </About>
        </>
      )}

    </div>
  );
}

export default RobinArzonLimitedTimeOfferingPDP;
